<div class="TotemWidget TotemWidgetChecklist card">
    <div class="card-body">
        <div class="TotemWidgetChecklist-Summary">
            <div class="d-flex justify-content-between mb-2">
                <div>
                    {{ 'totem-widget-checklist.checklist' | locTranslate }}
                </div>
                <div>
                    {{ 'totem-widget-checklist.completed' | locTranslate:'count':getCheckedCount():'total':(checkList?.length || 0) }}
                </div>
            </div>
            <div>
                <div class="progress mb-3" role="progressbar" [attr.aria-valuenow]="getCheckedCount()" aria-valuemin="0" [attr.aria-valuemax]="checkList?.length || 0">
                    <div class="progress-bar bg-{{ isAllChecked() ? 'success' : 'primary' }}" [style.transform]="'scale(' + (checkList?.length ? (getCheckedCount() / checkList.length) : 0) + ', 1)'"></div>
                </div>
                <div class="TotemWidgetChecklist-List" role="list">
                    @for (item of checkList; track item; let i = $index) {
                        @if (shouldShowCategory(i)) {
                            <div class="TotemWidgetChecklist-Category" role="presentation">
                                {{ 'totem-widget-checklist.category.' + item.category | locTranslate }}
                            </div>
                        }
                        <div role="listitem">
                            <div class="TotemWidgetChecklist-List-Item">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="TotemWidgetChecklist-List-Item-ToggleCheck d-flex align-items-center py-2" (click)="item.checked = !item.checked; onCheckedChange();">
                                        <span (click)="$event.stopPropagation()" class="me-3">
                                            <app-pg-switch
                                                [little]="true"
                                                [fieldId]="'checklist-item-' + id + '-' + i"
                                                [ariaLabelledBy]="'checklist-label-' + id + '-' + i"
                                                [(ngModel)]="item.checked"
                                                (ngModelChange)="onCheckedChange()">
                                            </app-pg-switch>
                                        </span>
                                        <label [id]="'checklist-label-' + id + '-' + i" [attr.for]="'checklist-item-' + id + '-' + i">{{ item.label }}</label>
                                    </div>
                                    @if (item.description) {
                                        <div class="TotemWidgetChecklist-List-Item-ToggleExtended">
                                            <button type="button" class="btn btn-link text-muted px-2 py-1" (click)="item.extended = !item.extended" [attr.aria-expanded]="!!item.extended">
                                                <i class="fa-regular fa-chevron-down" aria-hidden="true" [style.transform]="item.extended ? 'scale(1, -1)' : ''"></i>
                                            </button>
                                        </div>
                                    }
                                </div>

                                @if (item.description && item.extended) {
                                    <div class="TotemWidgetChecklist-List-Item-Description">
                                        <div class="border-top ms-3 ps-4 mt-2 py-2 pg-animation-slidedown">
                                            <small [innerHTML]="item.description | safe:'html'"></small>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
